export default "__VITE_PUBLIC_ASSET__8dc39563__"